import { AppState } from 'store/root.reducer'

export const selectVersion = (state: AppState) => state?.version.version
